<template>
  <head>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
  </head>

  <section class="relative h-screen w-full">
    
    <img src="/image/im3.jpg" alt="Contact Us" class="absolute top-0 left-0 w-full h-full object-cover z-0" />

    <div class="absolute inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center">
         <div class="w-1/2 p-10 flex flex-col justify-start text-left text-white font-serif bg-opacity-70">
        <div class="flex items-center mb-4 mt-10">
            <img src="/image/im8.png" alt="Logo HotelBook" class="h-14 w-14">
            <span class="ml-4 text-xl font-bold">UA University</span>
        </div>
        <h2 class="text-4xl font-bold mb-4">Bienvenue sur adminGate</h2>
        <p class="text-1xl italic mb-40">Connectez-vous pour accéder à votre espace personnel.</p>
        </div>
      <div class="flex w-[400px] max-w-6xl mx-auto bg-white bg-opacity-90 rounded-xl shadow-xl overflow-hidden">
        
       

        <!-- Formulaire de connexion à droite -->
        <div class="w-[400px] p-8 text-center space-y-6">
          <img src="/image/log.png" alt="Logo HotelBook" class="mx-auto h-20 w-20" />

          <p class="text-gray-700 text-sm italic font-serif">Une belle journée pour travailler!!!</p>

          <form @submit.prevent="login" class="space-y-8">
            <div>
              <input
                v-model="matricule"
                type="text"
                placeholder="Identifiant"
                required
                class="w-full border-b-2 border-gray-300 bg-transparent focus:outline-none focus:border-blue-500 p-2 font-serif placeholder-gray-500"
              />
            </div>

            <div>
              <input
                v-model="password"
                type="password"
                placeholder="Mot de passe"
                required
                class="w-full border-b-2 border-gray-300 bg-transparent focus:outline-none focus:border-blue-500 p-2 font-serif placeholder-gray-500"
              />
            </div>

            <button
              type="submit"
              class="px-6 py-2 bg-blue-900 text-white text-sm rounded-md hover:bg-blue-800 transition duration-300 font-serif"
            >
              Se connecter
            </button>
          </form>

          <p class="text-gray-600 text-xs font-serif"> &copy; 2025 University AdminGate — Tous droits réservés.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        email: '',
        password: '',
        user: null
      };
    },
    methods: {
      login() {
        fetch('https://mida-back.onrender.com/api/admin/login', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    matricule: this.matricule, 
    password: this.password
  })
})
.then(response => response.json())
.then(data => {
  if (data.access_token) {
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('niveau', data.user.niveau);
    localStorage.setItem('matricule', data.user.matricule);

    alert('Connexion réussie !');
    this.$router.push('/dash');
  } else {
    alert(data.message || 'Identifiants incorrects.');
  }
})
.catch(error => {
  console.error('Erreur lors de la connexion:', error);
  alert('Erreur de connexion. Vérifiez votre serveur.');
});

    }
  }
};
  </script>